module.exports = __webpack_public_path__ + "img/medical-brand-icon-border.590740f9.png";